import './DragAndDrop.css';
import { useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

function DragAndDrop({ setFiles, multipleFiles, width = "100%", height, acceptedTypes = ['pdf', 'docx', 'txt', 'xlsx', 'xls'], fileCount, insideCategoryDatabase = false }) {
    const [isDragging, setIsDragging] = useState(false);
    const { t: tDatabase } = useTranslation('database');
    const fileInputRef = useRef(null);
    const normalizedAcceptedTypes = useMemo(() => {
        const asArray = Array.isArray(acceptedTypes)
            ? acceptedTypes
            : String(acceptedTypes || '').split(',');

        return asArray
            .map((type) => String(type).trim().toLowerCase())
            .filter(Boolean)
            .map((type) => type.startsWith('.') ? type.slice(1) : type);
    }, [acceptedTypes]);

    const formatAcceptedForInput = normalizedAcceptedTypes
        .map((ext) => `.${ext}`)
        .join(',');

    const dynamicHeight = insideCategoryDatabase ? "100%" : height || "13.125rem";

    const isFileAccepted = (file) => {
        const extension = file.name.split('.').pop().toLowerCase();
        return normalizedAcceptedTypes.includes(extension);
    };

    const processFiles = (fileList) => {
        const filteredFiles = Array.from(fileList).filter(isFileAccepted);

        if (filteredFiles.length === 0) {
            alert(tDatabase('file_not_supported'));
            return;
        }

        if (multipleFiles) {
            setFiles(filteredFiles);
        } else {
            setFiles(filteredFiles[0]);
        }

        if (fileInputRef.current) {
            fileInputRef.current.value = null; // Limpa o input para permitir re-seleção do mesmo arquivo
        }
    };

    return (
        <div
            className={`upload-area ${isDragging ? 'dragging' : ''} ${insideCategoryDatabase ? 'inside-category' : ''}`}
            onDrop={(e) => {
                e.preventDefault();
                setIsDragging(false);
                processFiles(e.dataTransfer.files);
            }}
            onDragOver={(e) => e.preventDefault()}
            onDragEnter={() => setIsDragging(true)}
            onDragLeave={() => setIsDragging(false)}
            onClick={() => document.getElementById('file-input').click()}
        >
            <input
                id="file-input"
                type="file"
                accept={formatAcceptedForInput}
                onChange={(e) => processFiles(e.target.files)}
                multiple={multipleFiles}
                style={{ display: 'none' }}
                ref={fileInputRef}
            />
            <img src="/imagens/upload-icon.svg" alt={tDatabase("uploadIcon")} className="upload-icon" />
            <p>
                {multipleFiles ? tDatabase('drag_files') : tDatabase('drag_file')}<br />
                <span className="upload-link">{tDatabase('choose_file')}</span>
            </p>
        </div>
    );
}

export default DragAndDrop;
